import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import FooterFreeTrialEmailBlock from 'molecules/Footer/FooterFreeTrialEmailBlock';
import FooterSalesCallEmailBlock from 'molecules/Footer/FooterSalesCallEmailBlock';
import FooterLegal from 'molecules/Footer/FooterLegal';
import FooterLinks from 'molecules/Footer/FooterLinks';
import FooterLinksMobile from 'molecules/Footer/FooterLinksMobile';
import { MainLayout } from 'molecules/Header/Header/Header';

interface FooterProps {
  mainLayout?: MainLayout;
}

const Footer = ({ mainLayout = 'standard' }: FooterProps): JSX.Element => {
  return (
    <Stack
      direction='column'
      gap='spacing-7xl'
      background='bg-primary-solid'
      align='stretch'
      padding={['spacing-7xl', 'spacing-none', 'spacing-6xl', 'spacing-none']}
      dataCy='footer'
      data-track-section='footer'
    >
      <Grid
        totalColumns={1}
        maxWidth='width-3xl'
        maxWidthLg='width-md'
        padding={['spacing-none', 'spacing-4xl']}
        paddingSm={['spacing-none', 'spacing-xl']}
        margin={['spacing-none', 'spacing-auto']}
      >
        <Stack
          justify='space-between'
          align='flex-start'
          directionLg='column'
        >
          <FooterLinks />
          {mainLayout === 'pro' ? <FooterSalesCallEmailBlock /> : <FooterFreeTrialEmailBlock />}
          <FooterLinksMobile />
        </Stack>
      </Grid>
      <FooterLegal />
    </Stack>
  );
};

export default Footer;
